
import Component from './component';
import createComponentFactory from '../createComponent';
import Swiper from 'swiper/dist/js/swiper.js';

const defaultOptions = {
  tabs: '.js-tab__tabs',
  tab: '.js-tab__tab',
  container: '.js-tab__container',
  content: '.js-tab__content'
};

class CrossFadeTab extends Component {

  constructor(element, context, options) {
    super(element, context, Object.assign({}, defaultOptions, options));

    this.tabs = element.querySelector(this.options.tabs);
    this.tab = element.querySelectorAll(this.options.tab);
    this.container = element.querySelector(this.options.container);
    this.content = element.querySelectorAll(this.options.content);

    this._currentIndex = 0;

    this._handleTabClick = this._handleTabClick.bind(this);
    this._handleSliderTransitionStart = this._handleSliderTransitionStart.bind(this);
    this._handleLoadEntryComplete = this._handleLoadEntryComplete.bind(this);
  }

  _addEvents() {

    for(let tab of this.tab) {
      tab.addEventListener('click', this._handleTabClick);
    }

    this.context.dispatcher.on('completeLoadMore', this._handleLoadEntryComplete);
  }

  _removeEvents() {

    for(let tab of this.tab) {
      tab.removeEventListener('click', this._handleTabClick);
    }

    this.context.dispatcher.off('completeLoadMore', this._handleLoadEntryComplete);
  }

  _handleLoadEntryComplete() {
    this._tabContext.updateAutoHeight();
  }

  _handleTabClick(evt) {


    evt.preventDefault();
    evt.stopImmediatePropagation();

    let target = evt.target;


    if(target.nodeName.toLowerCase() !== 'a') {
      target = target.querySelector('a');
    }

    if(!target) {
      return;
    }

    const hash = target.hash;
    const contents = Array.prototype.slice.call(this.content);
    const targetContent = document.getElementById(hash.substring(1));

    if(!targetContent) {
      return;
    }

    const index = contents.indexOf(targetContent);

    for(let val of this.tab) {
      val.removeAttribute('data-selected');
    }
    target.parentNode.setAttribute('data-selected', 'true');
    this._tabContext.slideTo(index);
    this._updateSelectedTab(index);

    this._currentIndex = index;
  }

  _updateSelectedTab(index) {
    const currentTab = this.tab[this._currentIndex];
    const nextTab = this.tab[index];


    delete currentTab.dataset.selected;

    nextTab.dataset.selected = true;

  }

  _initTab() {
    this._tabContext = new Swiper(this.container, {
      effect: 'fade',
      allowTouchMove: false,
      autoHeight: true,
      fadeEffect: {
        crossFade: true
      }
    });
    this.tab[0].setAttribute('data-selected', 'true');

    this._tabContext.on('slideChangeTransitionEnd', this._handleSliderTransitionStart);
  }

  _handleSliderTransitionStart() {
  }

  _destroyTab() {

  }

  didRegisterComponent() {

    if(this.tab.length === 0) {
      return;
    }

    this._initTab();
    this._addEvents();

  }


  didUnregisterComponent() {

    if(this.tab.length === 0) {
      return;
    }

    this._destroyTab();
    this._removeEvents();
  }
}

export default createComponentFactory(CrossFadeTab);



// WEBPACK FOOTER //
// ./src/js/app/component/crossFadeTab.js